// extracted by mini-css-extract-plugin
export default {"hail":"Hail_hail__smtmI","detail":"Hail_detail__BuV1U","key":"Hail_key__3Mznl","value":"Hail_value__psudn"};